import Vue from 'vue';
import 'xe-utils';
import VXETable from 'vxe-table';
import 'vxe-table/lib/style.css';
import VXETablePluginElement from 'vxe-table-plugin-element';

Vue.use(VXETable);
VXETable.use(VXETablePluginElement);

VXETable.setup({
  size: 'medium',
  resizable: true,
  version: 0,
  // 默认消息提示框参数
  // message: {
  //   zIndex: 999,
  //   lockView: true,
  //   lockScroll: true,
  //   mask: true,
  //   duration: 3000,
  //   animat: true
  // },
  // 默认优化配置项
  optimization: {
    animat: true,
    // 当表头大于 60 列时自动启用横向 X 滚动渲染
    scrollX: {
      gt: 60
    },
    // 当行数据大于 300 条时自动启用纵向 Y 滚动渲染
    scrollY: {
      gt: 300
    }
  }
});

// 自定义DOM
VXETable.renderer.add('customDom', {
  renderDefault (h, cellRender, params) {
    let { row, column } = params;
    let { formater } = cellRender;
    return [formater(params)];
  }
});

// 自定义select
VXETable.renderer.add('customSelect', {
  renderDefault (h, renderOpts, params) {
    let { options, optionProps, events = {} } = renderOpts;
    let { row, column } = params;
    let isDisabled = false;

    if (!events.change) {
      events.change = () => {};
    }
    if (!events.focus) {
      events.focus = () => {};
    }
    if (renderOpts.disabled) {
      isDisabled = renderOpts.disabled(params);
    }
    return [
      <el-select
        loading={renderOpts.loading}
        disabled={isDisabled}
        filterable={renderOpts.filterable}
        v-model={row[column.property]}
        onChange={($event) => { events.change({ row, column, value: $event }); }}
        onFocus={() => { events.focus({ row, column }); }}
      >
        {
          options.map((item, index) => {
            return (
              <el-option
                key={index}
                label={item[optionProps.label]}
                value={item[optionProps.value]}
              >
              </el-option>
            );
          })
        }
      </el-select>
    ];
  }
});

// 自定义空数据
VXETable.renderer.add('customEmpty', {
  // 空内容模板
  renderEmpty (h, renderOpts) {
    let { formater } = renderOpts;
    return [formater()];
  }
});

// 计数器
VXETable.renderer.add('inputNumber', {
  // 可编辑激活模板
  renderEdit (h, renderOpts, { row, column }) {
    let { tableProp, events } = renderOpts;
    tableProp = tableProp || {};
    if (tableProp instanceof Object) {
      if (tableProp.maxKey) {
        tableProp.max = Number(row[tableProp.maxKey]);
      }
      if (tableProp.minKey) {
        tableProp.min = Number(row[tableProp.minKey]);
      }
      if (!tableProp.maxKey && typeof tableProp.max !== 'number') {
        tableProp.max = 9999999999;
      }
      if (!tableProp.minKey && typeof tableProp.min !== 'number') {
        tableProp.min = 0;
      }
      if (tableProp.controls !== false) {
        tableProp.controls = true;
      }
    } else {
      tableProp = {};
      tableProp.min = 0;
      tableProp.max = 9999999999;
    }
    tableProp.precision = tableProp.precision ? tableProp.precision : 0;
    return [
      <el-input-number
        min={ tableProp.min }
        max={ tableProp.max }
        controls={ tableProp.controls }
        v-model={ row[column.property] }
        change={ events.change({ row, column }) }
        precision={tableProp.precision}
      >

      </el-input-number>
    ];
  },
  // 可编辑显示模板
  renderCell (h, renderOpts, { row, column }) {
    return [
      <span>{ row[column.property] ? row[column.property] : 0 }</span>
    ];
  }
});

// 自定义编辑模式select
VXETable.renderer.add('editSelect', {
  renderEdit (h, renderOpts, params) {
    let { options, optionProps, events = {} } = renderOpts;
    let { row, column } = params;
    let isDisabled = false;
    if (!events.change) {
      events.change = () => {};
    }
    if (!events.focus) {
      events.focus = () => {};
    }
    if (renderOpts.disabled) {
      isDisabled = renderOpts.disabled(params);
    }
    if (!optionProps.remoteMethod) {
      optionProps.remoteMethod = () => {};
    }
    return [
      <el-select
        disabled={ isDisabled }
        v-model={ row[column.property] }
        filterable={ optionProps.filterable }
        remote={ optionProps.remote }
        reserve-keyword={ optionProps.reserveKeyword }
        placeholder={ optionProps.placeholder ? optionProps.placeholder : '' }
        loading={ optionProps.loading }
        clearable={ optionProps.clearable }
        remote-method={ optionProps.remoteMethod }
        onChange={() => { events.change({ row, column }); }}
        onFocus={() => { events.focus({ row, column }); }}
      >
        {
          options.map((item, index) => {
            return (
              <el-option
                key={ index }
                label={ item[optionProps.label ? optionProps.label : 'label'] }
                value={ item[optionProps.value ? optionProps.value : 'value'] }
              >
              </el-option>
            );
          })
        }
      </el-select>
    ];
  },
  renderCell (h, renderOpts, { row, column }) {
    return [
      <span>{ row[column.property] ? row[column.property] : 0 }</span>
    ];
  }
});

// //弹框模板
// VXETable.renderer.add('dialogCell', {
//   renderDefault (h, cellRender, params) {
//     let { extraHandler, tableProp, defaultText } = cellRender;
//     let { row, column } = params;
//     defaultText = defaultText ? defaultText : "添加";
//     return [
//       <el-button class="vxe_editDialog" type="text" onClick={()=>{ extraHandler({row,column}) }}>
//         { row[column.property] ? row[column.property] : defaultText }
//       </el-button>
//     ]
//   }
// });

// //表格弹框激活模板
// VXETable.renderer.add('editDialog', {
//   // 可编辑激活模板
//   renderEdit (h, renderOpts, { row, column }) {
//     let { extraHandler, tableProp, defaultText } = renderOpts;
//     defaultText = defaultText ? defaultText : "添加";
//     return [
//       <el-button class="vxe_editDialog" type="text" onClick={()=>{ extraHandler({row,column}) }}>
//         { row[column.property] ? row[column.property] : defaultText }
//       </el-button>
//     ]
//   },
//   // 可编辑显示模板
//   renderCell (h, renderOpts, { row, column }) {
//     let { defaultText } = renderOpts;
//     defaultText = defaultText ? defaultText : "添加";
//     return [
//       <span class="vxe_editDialog">{ row[column.property] ? row[column.property] : defaultText }</span>
//     ]
//   }
// })
